import { useQuery } from '@tanstack/react-query';
import { createApiClient } from '../api/client';
import { useAccessToken } from '../auth/useAuth';
import type { DashboardSummaryResponse } from '../api/types';
import { useWorkspace } from '../workspace/WorkspaceProvider';
import { workspaceKey } from './workspaceQueryKey';

/**
 * The Dashboard's counts + near-expiry-documents summary (PS6) — a single
 * request replacing what used to be several full, unpaginated list fetches
 * (documents/entities/contacts/connections/members/invites) made purely to
 * derive a `.length` or an expiry badge. Assets/accounts/liabilities are
 * still fetched in full by the Dashboard, since it also needs their per-record
 * values for the net-worth hero, allocation strip, and largest-holdings list.
 */
export function useDashboardSummary() {
  const token = useAccessToken();
  const { activeWorkspaceId } = useWorkspace();
  return useQuery({
    queryKey: workspaceKey('dashboard-summary', activeWorkspaceId),
    queryFn: () => createApiClient(token!).get<DashboardSummaryResponse>('/dashboard/summary'),
    enabled: !!token && !!activeWorkspaceId,
  });
}
